import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material/";
import CleansingMenu from "./Menu/CleansingMenu";
import FragranceMenu from "./Menu/FragranceMenu";
import ShoeMenu from "./Menu/ShoeMenu";
import Gallery from "./Gallery";

import Reviews from "../../Review/Reviews";
import { useStateContext } from "../../../context/StateContext_KO";
import { useProductContext } from "../../../context/ProductContext";
import { HashLink } from "react-router-hash-link";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CheckoutDrawer_KO from "./CheckoutDrawer_KO";
import "./Product.css";
import { useParams, useLocation } from "react-router-dom";
import Details from "./Details";
import AddTaskIcon from "@mui/icons-material/AddTask";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FeaturedProductRecent from "../../User/Cart/FeaturedProductRecent";
import FeaturedProductsBestSellers from "../../User/Cart/FeaturedProductsBestSellers";
import AirIcon from "@mui/icons-material/Air";
import Alert from "@mui/material/Alert";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { useTranslation } from "react-i18next";
import CurrencyFormat from "react-currency-format";
import {
  db,
  collection,
  query,
  orderBy,
  getDocs,
  getDoc,
  doc,
} from "../../../firebase";
import ReviewRatingStar from "./ReviewRatingStar";
import { analytics, setUserProperties } from "../../../firebase";

import {
  EmailShareButton,
  FacebookShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from "react-share";
import Button from "@mui/material/Button";
import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
} from "react-share";
import Modal from "@mui/material/Modal";
import ProductInfo from "./ProductInfo";

const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const Product_KO = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://developers.kakao.com/sdk/js/kakao.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  document.title = "Heslet Product";
  const { t, i18n } = useTranslation();
  const url = window.location.href;

  const handleOpen = () => setOpen(true);

  const location = useLocation();

  const [quantity, setQuantity] = useState(1);
  const {
    addToBasket,
    ChangeQuantityToBasket,
    basket,
    modifyQuantityInBasket,
    setBasket,
  } = useStateContext();
  const MAXIMUM_QUANTITY = 5;
  const { products } = useProductContext();

  const { productName } = useParams();
  const [productIndex, setProductIndex] = useState(null);
  const [rating, setRating] = useState(null);

  const [reviews, setReviews] = useState([]);
  const [numOfProduct, setNumOfProduct] = useState(null);
  const [quantityAlert, setQuantityAlert] = useState(null);
  const [stop, setStop] = useState(false);

  const [quantityInBasket, setQuantityInBasket] = useState(0);
  const [country, setCountry] = useState(null);
  console.log("basket", basket);

  useEffect(() => {
    if (window.sessionStorage.getItem("iplookup")) {
      let iplookup = JSON.parse(window.sessionStorage.getItem("iplookup"));
      console.log("=================== iplookup", iplookup);
      setCountry(iplookup.countryCode);
    }
  }, []);

  // Start of Snack bar
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  // Share modal
  const [openShare, setOpenShare] = React.useState(false);
  const handleShareClick = () => {
    setOpenShare(true);
  };
  const handleShareClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenShare(false);
  };
  // Share modal

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  // End of Snack bar

  console.log("productIndex++++++", productIndex);
  console.log(
    "sessionStorage.getItem(viewed)+++++",
    sessionStorage.getItem("viewed")
  );
  useEffect(() => {
    let viewed = sessionStorage.getItem("viewed");
    if (!sessionStorage.getItem("viewed")) {
      viewed = [];
    }
    let newlist = [];
    let arr = viewed;

    if (productIndex > -1 && productIndex !== null) {
      if (!viewed) {
        newlist = [productIndex + "/"];
        sessionStorage.setItem("viewed", newlist);
      } else {
        console.log("****************     viewed", viewed);
        let remove = productIndex + "/";
        if (viewed.includes(remove)) {
          console.log("remove found");
          viewed = viewed.replaceAll(remove, "");
          console.log("after remove", viewed);
        }
        newlist = viewed.concat("" + productIndex + "/");
        sessionStorage.setItem("viewed", newlist);
      }
    }
  }, [productIndex]);

  console.log(sessionStorage.getItem("viewed"));
  // console.log("productIndex", productIndex);

  useEffect(() => {
    setQuantityAlert(null);
    setQuantity(1);
  }, [location]);

  useEffect(() => {
    setQuantityAlert("");
  }, []);
  console.log(quantity);
  const changeQuantityByOne = (action) => {
    if (action === "minus") {
      if (quantity > 1) {
        setQuantityAlert(null);
        setQuantity((old) => old - 1);
      }
    } else {
      setQuantity((old) => old + 1);
    }
  };
  const getReviews = async (index) => {
    setReviews([]);
    let dbName =
      JSON.parse(window.sessionStorage.getItem("iplookup")).countryCode +
      "_" +
      "reviews_" +
      products[index].productId;

    let ref = await collection(db, dbName);

    const q = query(ref, orderBy("created", "desc"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // console.log(doc.id, " => ", doc.data());

      setReviews((old) => old.concat({ ...doc.data(), id: doc.id }));
    });
  };
  useEffect(() => {
    console.log("**************** productName changed");
    // console.log("reviews", reviews);
    const total = reviews.reduce(
      (prevValue, currentValue) => prevValue + currentValue.rating,
      0
    );
    setRating(total / reviews.length);
  }, [reviews, rating]);

  useEffect(() => {
    let index;
    products.map((product, idx) => {
      if (product.linkTo === productName) {
        index = idx;
      }
    });
    setProductIndex(index, getReviews(index));

    setUserProperties(analytics, { product_clicked: products[index].title });
    const get = async () => {
      const proId = products[index].productId;
      console.log("proId", proId);
      const docRef = doc(db, "KO_products", proId.trim());
      console.log("proId.trim()", proId.trim());
      const docSnap = await getDoc(docRef);

      console.log("docSnap.exists()", docSnap.exists());
      if (docSnap.exists()) {
        if (docSnap.data().stop === "true") {
          setStop(true);
        } else {
          setStop(false);
        }
        setNumOfProduct(docSnap.data().quantity);

        console.log("docSnap.data().quantity=====> ", docSnap.data().quantity);
      }
    };
    get();
  }, [productName]);

  const addToContextBasket = () => {
    let basketQuantity = quantity;
    console.log("numOfProduct", numOfProduct);
    console.log("basketQuantity", basketQuantity);

    if (basketQuantity) {
      addToBasket(
        {
          id: products[productIndex].productId,
          price: products[productIndex].price_KO,
          priceId: products[productIndex].priceId,
          group: products[productIndex].group,
          quantity: basketQuantity,
          image: products[productIndex].img,
          name: products[productIndex].title,
          linkTo: products[productIndex].linkTo,
        },
        numOfProduct
      );
    }

    // if (
    //   JSON.parse(window.sessionStorage.getItem("iplookup")).countryCode === "US"
    // ) {
    //   if (basketQuantity) {
    //     addToBasket({
    //       id: products[productIndex].productId,
    //       price: products[productIndex].price,
    //       priceId: products[productIndex].priceId,
    //       group: products[productIndex].group,
    //       quantity: basketQuantity,
    //       image: products[productIndex].img,
    //       name: products[productIndex].title,
    //       linkTo: products[productIndex].linkTo,
    //     });
    //   }
    // } else if (
    //   JSON.parse(window.sessionStorage.getItem("iplookup")).countryCode === "KO"
    // ) {
    //   if (basketQuantity) {
    //     addToBasket({
    //       id: products[productIndex].productId,
    //       price: products[productIndex].price_Ko,
    //       priceId: products[productIndex].priceId,
    //       group: products[productIndex].group,
    //       quantity: basketQuantity,
    //       image: products[productIndex].img,
    //       name: products[productIndex].title,
    //       linkTo: products[productIndex].linkTo,
    //     });
    //   }
    // } else {
    //   // Other Country
    // }

    // if (numOfProduct < basketQuantity) {
    //   ChangeQuantityToBasket(productIndex, numOfProduct);
    // }
    // if (MAXIMUM_QUANTITY < basketQuantity) {
    //   ChangeQuantityToBasket(productIndex, numOfProduct);
    // }
    handleClick();
  };

  let show;
  if (
    products[productIndex]?.group === "cleansing" ||
    products[productIndex]?.group === "pet"
  ) {
    show = <CleansingMenu />;
  } else if (products[productIndex]?.group === "fragrance") {
    show = <FragranceMenu />;
  } else {
    show = <ShoeMenu />;
  }

  function shareTwitter() {
    var sendText = "Heslet"; // 전달할 텍스트
    var sendUrl = window.location.href; // 전달할 URL
    window.open(
      "https://twitter.com/intent/tweet?text=" + sendText + "&url=" + sendUrl
    );
  }

  // useEffect(() => {
  //   window.Kakao.init("14b3e7a4ac26ccd16c1a7e1f5ca1400e");
  // }, []);

  // const kak = () => {
  //   window.Kakao.Link.createDefaultButton({
  //     container: "#kakao-link-btn",
  //     objectType: "feed",
  //     content: {
  //       title: "딸기 치즈 케익",
  //       description: "#케익 #딸기 #삼평동 #카페 #분위기 #소개팅",
  //       imageUrl:
  //         "http://mud-kage.kakao.co.kr/dn/Q2iNx/btqgeRgV54P/VLdBs9cvyn8BJXB3o7N8UK/kakaolink40_original.png",
  //       link: {
  //         mobileWebUrl: "https://cheonmro.github.io/",
  //         webUrl: "https://cheonmro.github.io/",
  //       },
  //     },
  //     social: {
  //       likeCount: 286,
  //       commentCount: 45,
  //       sharedCount: 845,
  //     },
  //     buttons: [
  //       {
  //         title: "웹으로 보기",
  //         link: {
  //           mobileWebUrl: "https://cheonmro.github.io/",
  //           webUrl: "https://cheonmro.github.io/",
  //         },
  //       },
  //       {
  //         title: "앱으로 보기",
  //         link: {
  //           mobileWebUrl: "https://cheonmro.github.io/",
  //           webUrl: "https://cheonmro.github.io/",
  //         },
  //       },
  //     ],
  //   });
  // };

  console.log("numOfProduct", numOfProduct);
  console.log("products[productIndex]", products[productIndex]);

  return (
    <>
      <section id="top"></section>
      <Modal
        open={openShare}
        onClose={handleShareClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box>{t("Share With Us")}</Box>

            <Box sx={{ display: "flex", ml: 2 }}>
              <Box>
                <EmailShareButton
                  url={url}
                  subject={"Heslet LLC"}
                  body="body"
                  className="Demo__some-network__share-button"
                >
                  <EmailIcon size={32} round />
                </EmailShareButton>
              </Box>
              <Box sx={{ paddingLeft: "3px" }}>
                <FacebookShareButton url={url} quote={"Heslet LLC"}>
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <div></div>
              </Box>
              <Box sx={{ paddingLeft: "3px" }}>
                <TwitterShareButton
                  url={url}
                  title={"Helset LLC"}
                  className="Demo__some-network__share-button"
                >
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
              </Box>
              <Box>
                <InstapaperShareButton
                  url={url}
                  title={"Heslet LLC"}
                  className="Demo__some-network__share-button"
                >
                  <InstapaperIcon
                    size={32}
                    round
                    style={{ marginLeft: "3px" }}
                  />
                </InstapaperShareButton>
              </Box>
              <Box sx={{ paddingLeft: "3px" }}>
                <PinterestShareButton
                  url={String(window.location)}
                  media={`${String(
                    window.location
                  )}/${"gs://prism-a6a80.appspot.com/prod_L3e4fNWKRAKHAv/52936181872124"}`}
                  className="Demo__some-network__share-button"
                >
                  <PinterestIcon size={32} round />
                </PinterestShareButton>

                {/* <div>
                    <PinterestShareCount
                      url={url}
                      className="Demo__some-network__share-count"
                    />
                  </div> */}
              </Box>
              <Box>
                <RedditShareButton
                  url={url}
                  title={"Heslet LLC"}
                  windowWidth={660}
                  windowHeight={460}
                  className="Demo__some-network__share-button"
                >
                  <RedditIcon size={32} round style={{ marginLeft: "3px" }} />
                </RedditShareButton>

                {/* <div>
                    <RedditShareCount
                      url={url}
                      className="Demo__some-network__share-count"
                    />
                  </div> */}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Grid container sx={{ px: { md: 10, sm: 6, xs: 6 } }}>
        {show}
        <Grid item md={8} sm={12} sx={{ pb: 2, pt: 2, display: "flex" }}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={5}
              sx={{
                width: 1,
                height: { xs: "390px" },
                display: "flex",
                alignItems: "center",
                position: "relative",
                left: "-30px",
                flexDirection: "column",
              }}
            >
              {products[productIndex]?.imgs && (
                <Gallery imgs={products[productIndex]?.imgs} />
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              sx={{
                pt: 5,
                pb: 5,
                textAlign: { sm: "center", md: "left" },
              }}
            >
              <Box
                sx={{
                  borderRadius: "20px",
                  color: "#393939",
                }}
              >
                <Box
                  sx={{
                    color: "gray",
                    borderBottom: "1px solid #3d3d4f",
                    width: "fit-content",
                    paddingTop: "1px",
                    // borderRadius: "3px",
                    mb: 2,
                    fontSize: "11px",
                  }}
                >
                  It's All Good
                </Box>
                <Box
                  className="menu_title"
                  sx={{
                    fontSize: "11px",
                    color: "gray",
                  }}
                >
                  {t(products[productIndex]?.title)}
                </Box>
                <Box
                  className="menu_title"
                  sx={{
                    mt: { sm: 5, xs: 5, md: 1 },
                    fontSize: "19px",
                    fontWeight: 800,
                    lineHeight: "160%",
                  }}
                >
                  {t(products[productIndex]?.subtitle)}
                </Box>
                {/* <Box sx={{ pt: 1, color: "#9e9e9e", lineHeight: "1.7em" }}>
                  {t(products[productIndex]?.list[0].details[0])}{" "}
                  <Box>{t(products[productIndex]?.list[0].details[1])} </Box>
                </Box> */}

                <Box
                  sx={{
                    display: "flex",
                    width: 1,

                    justifyContent: {
                      sx: "center",
                      md: "flex-start",
                      xs: "flex-start",
                    },
                  }}
                >
                  {!isNaN(rating) && (
                    <>
                      <ReviewRatingStar rating={rating} />
                      <HashLink to="#review">
                        <Box
                          sx={{
                            pl: 1,
                            fontSize: "15px",
                            paddingTop: "18px",
                          }}
                          className="pink_link"
                        >
                          {reviews.length > 2
                            ? reviews.length + " Reviews"
                            : reviews.length + " Review"}
                        </Box>
                      </HashLink>
                    </>
                  )}
                </Box>
                <Box sx={{ pt: 2 }}>{products[productIndex]?.volumn}</Box>

                <Box
                  sx={{
                    paddingTop: "2px",
                    display: "flex",
                  }}
                >
                  <FiberManualRecordIcon
                    sx={{
                      color: numOfProduct > 0 ? "green" : "red",
                      fontSize: "15px",
                      pr: "2px",
                      pt: "2px",
                    }}
                  />{" "}
                  <span
                    style={{
                      color: numOfProduct > 0 ? "green" : "red",
                      paddingTop: "2px",
                    }}
                  >
                    {numOfProduct > 0 ? t("In stock") : t("Out of stock")}
                  </span>
                  <Box
                    sx={{ ml: 2, textDecoration: "none", color: "#153a5a" }}
                    className=""
                  >
                    {numOfProduct > 0 && numOfProduct && numOfProduct < 10
                      ? t("Only ") + numOfProduct + t(" left")
                      : null}
                  </Box>
                </Box>

                <Box
                  sx={{
                    pt: 2,
                    fontSize: "24px",
                    fontWeight: "bold",
                    mb: 2,
                    color: "#153a5a",
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "left" }}>
                    <Box sx={{ color: "#6b90db", pr: 2 }}>20%</Box>
                    <Box>
                      <span
                        style={{
                          textDecoration: "line-through",
                          fontSize: "14px",
                          color: "gray",
                        }}
                      >
                        <CurrencyFormat
                          value={+products[productIndex]?.price_KO / 0.8}
                          displayType={"text"}
                          thousandSeparator={true}
                          suffix={"원"}
                        />
                      </span>{" "}
                      <span
                        style={{
                          fontWeight: 800,
                          fontSize: "20px",
                          color: "black",
                        }}
                      >
                        <CurrencyFormat
                          value={products[productIndex]?.price_KO}
                          displayType={"text"}
                          thousandSeparator={true}
                          suffix={"원"}
                        />
                      </span>
                    </Box>
                  </Box>
                  {/* {JSON.parse(window.sessionStorage.getItem("iplookup"))
                    .countryCode === "KO" ? (
                    <Box>
                      <span
                        style={{
                          textDecoration: "line-through",
                          fontSize: "22px",
                          color: "gray",
                        }}
                      >
                        <CurrencyFormat
                          value={products[productIndex]?.price + 1}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </span>{" "}
                      <CurrencyFormat
                        value={products[productIndex]?.price}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </Box>
                  ) : (
                    <Box>
                      <span
                        style={{
                          textDecoration: "line-through",
                          fontSize: "22px",
                          color: "gray",
                        }}
                      >
                        <CurrencyFormat
                          value={products[productIndex]?.price_Ko}
                          displayType={"text"}
                          thousandSeparator={true}
                          suffix={"원"}
                        />
                      </span>{" "}
                      <CurrencyFormat
                        value={products[productIndex]?.price_Ko}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={"원"}
                      />
                    </Box>
                  )} */}
                </Box>
                <Box
                  sx={{
                    pt: 1,
                    display: "flex",
                    position: "relative",
                    flexDirection: "column",
                    // borderTop: "1px solid lightgray",
                    // borderBottom: "1px solid lightgray",
                    mt: 1,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box className="menu_bredcrumb" sx={{ pb: 1 }}>
                    {t("Select Quantity")}
                  </Box>

                  <Box sx={{ display: "flex" }}>
                    {!stop ? (
                      <div
                        class="input-group"
                        style={{
                          border: "1px solid lightgray",
                          width: "138px",
                          height: "49px",
                          marginRight: "20px",
                        }}
                      >
                        <Box sx={{ position: "relative", left: "+7px" }}>
                          <input
                            type="button"
                            value="-"
                            class="button-minus"
                            data-field="quantity"
                            onClick={() => changeQuantityByOne("minus")}
                            style={{
                              backgroundColor: "white",
                              borderColor: "white",
                              fontSize: "22px",
                              height: "42px",
                              position: "relative",
                              top: "+2px",
                            }}
                          />
                          <input
                            type="number"
                            step="1"
                            max=""
                            value={quantity}
                            name="quantity"
                            class="quantity-field"
                            style={{
                              height: "42px",
                              borderColor: "white",
                              position: "relative",
                              top: "-1px",
                            }}
                          />
                          <input
                            type="button"
                            value="+"
                            class="button-plus"
                            data-field="quantity"
                            onClick={() => changeQuantityByOne("plus")}
                            style={{
                              backgroundColor: "white",
                              borderColor: "white",
                              fontSize: "22px",
                              position: "relative",
                              top: "+6px",
                              height: "42px",
                            }}
                          />
                        </Box>
                      </div>
                    ) : null}

                    {stop ? (
                      t(
                        "Sorry. This product is not available to order right now"
                      )
                    ) : (
                      <CheckoutDrawer_KO
                        quantityToAdd={quantity}
                        productIndex={productIndex}
                        addToContextBasket={addToContextBasket}
                        numOfProduct={numOfProduct}
                        productId={products[productIndex]?.productId}
                      />
                    )}
                  </Box>
                  <Box sx={{ mt: 2 }}>
                    {quantityAlert && (
                      <Alert severity="info">{quantityAlert}</Alert>
                    )}
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  fontSize: "15px",
                  color: "#424242",
                  lineHeight: "190%",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  {products[productIndex]?.icon.includes("plant") ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100px",
                        borderRight: "1px solid lightgray",
                        alignItems: "center",
                        paddingRight: "10px",
                      }}
                    >
                      <img width="24" src="/img/leaf.png" alt="" />
                      <Box
                        sx={{
                          fontSize: "11px",
                          lineHeight: "1.3em",
                          textAlign: "center",
                          pt: 1,
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: t("plant based") }}
                        ></div>
                      </Box>
                    </Box>
                  ) : null}

                  {products[productIndex]?.icon.includes("no-bacteria") ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100px",
                        borderRight: "1px solid lightgray",
                        alignItems: "center",
                        paddingRight: "10px",
                        paddingLeft: "10px",
                      }}
                    >
                      <img width="35" src="/img/no-bateria.jpeg" alt="" />
                      <Box
                        sx={{
                          fontSize: "11px",
                          lineHeight: "1.3em",
                          textAlign: "center",
                          pt: 1,
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: t("no bacteria") }}
                        ></div>
                      </Box>
                    </Box>
                  ) : null}
                  {products[productIndex]?.icon.includes("air") ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100px",
                        alignItems: "center",
                        paddingLeft: "0px",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: "32px",
                          width: "30px",
                          height: "27px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <AirIcon sx={{ fontSize: "27px" }} />
                      </Box>
                      <Box
                        sx={{
                          fontSize: "10px",
                          lineHeight: "1.3em",
                          textAlign: "center",
                          pt: 1,
                        }}
                      >
                        AIR <br />
                        PURIFICATION
                      </Box>
                    </Box>
                  ) : null}
                  {products[productIndex]?.icon.includes("korea") ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100px",
                        alignItems: "center",
                        paddingLeft: "0px",
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: "32px",
                          width: "30px",
                          height: "27px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <AddTaskIcon sx={{ fontSize: "28px" }} />
                      </Box>
                      <Box
                        sx={{
                          fontSize: "10px",
                          lineHeight: "1.3em",
                          textAlign: "center",
                          pt: 1,
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t("made in korea"),
                          }}
                        ></div>
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              </Box>
              <Box
                sx={{
                  // borderTop: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={handleShareClick}
              >
                <ShareOutlinedIcon
                  sx={{
                    color: "gray",
                    fontSize: "18px",
                    position: "relative",
                    top: "15px",
                    left: "+5px",
                    cursor: "pointer",
                  }}
                />
                <Box
                  sx={{
                    position: "relative",
                    top: "+17px",
                    left: "+12px",
                    color: "gray",
                    cursor: "pointer",
                  }}
                >
                  {t("Share")}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          {products[productIndex] && (
            <Details list={products[productIndex]?.list} />
          )}
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          {/* Premium All purpose  */}
          {products[productIndex]?.productId === "prod_L0ydT6J1tc5YaN" && (
            <>
              {/* <AllPurpose /> */}
              {/* <CompareTable /> */}
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Heavy Duty */}
          {products[productIndex]?.productId === "prod_L0ydT6J1tc5Yaa" && (
            <>
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Premium All Purpose Spray */}
          {products[productIndex]?.productId === "prod_L3e4fNWKRAKHAv" && (
            <>
              {/* <AllPurposeSpray /> */}

              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Flushable */}
          {products[productIndex]?.productId === "prod_L87ZLxB6ZdPY46" && (
            <>
              {/* <Flushable /> */}
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Pet spray */}
          {products[productIndex]?.productId === "prod_L87lCnUUuPfoV8" && (
            <>
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Shoe Cleaner Wipe */}
          {products[productIndex]?.productId === "prod_LQUBQLWAq89tSv" && (
            <>
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Shoe Cleaner Spray */}
          {products[productIndex]?.productId === "prod_LQUNCp56fHwxb6" && (
            <>
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Shoe Nano Coating Spray */}
          {products[productIndex]?.productId === "prod_LQUTfKii0FBCxG" && (
            <>
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Shoe Nano Coating Gel */}
          {products[productIndex]?.productId === "prod_LS8FQM6rZKa4O9" && (
            <>
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}
          {/* Shoe Anti-Baterial Deodorization Spray */}
          {products[productIndex]?.productId === "prod_LS8HPrzBMiQqbE" && (
            <>
              <section id="review"></section>
              <Reviews
                rating={rating}
                productId={products[productIndex].productId}
                name={products[productIndex].title}
                link={products[productIndex].linkTo}
              />
            </>
          )}

          <Box sx={{ px: 0 }}>
            <FeaturedProductRecent currentLocation={"KO"} />
            <FeaturedProductsBestSellers currentLocation={"KO"} />
          </Box>
          <Box>
            <ProductInfo />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Product_KO;
